import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchTermservice } from '../../services/search/search-service.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ContactUsDialogComponent } from '../contact-us-dialog/contact-us-dialog.component';
import { DueDiligenceDeleteDialogComponent } from '../due-diligence-delete-dialog/due-diligence-delete-dialog.component';
import { DueDiligenceDialogComponent } from '../due-diligence-dialog/due-diligence-dialog.component';
import { RoleGuardService } from '../../security/role-guard.service';
import { environment } from '../../../environments/environment';
import {SharedVals} from '../../../shared/SharedVals';
import { OktaAuthService } from '@okta/okta-angular';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {

  msg: string;
  headerValidationmsg: string;
  userName: string;
  showHide: boolean;
  searchBar;
  searchIcon: boolean = false;
  enterDisable: boolean = false;
  username = new FormControl();
  iserror: boolean = true;
  iserror2: boolean = false;
  showToggle: boolean = false;
  parIsSelected: boolean = false;
  agentIsSelected: boolean = false;
  globalSearch: boolean = true;
  parclicked: any;
  agentclicked: any;
  homeBtnDisable: boolean = true;
  parManagerRole: boolean = false;
  qacRole: boolean = false;
  public errMsg: any;
  public typeErr: boolean = false;
  isNavigate: string;
  SiteAdminLogin: boolean = false;
  ResolutionLogin: boolean = false;
  HomePage: boolean = true;
  agentId: any;
  ResolutionManagerLogin: boolean = false;
  role: any;
  constructor(private roleGuardService: RoleGuardService,
    private userservice: UserService,
    public oktaAuth: OktaAuthService,
    private SearchTermservice: SearchTermservice,
    private router: Router, public sharedVals:SharedVals,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.sharedVals.role.subscribe(res=>{
     this.role = res;
     
    // var role = localStorage.getItem('Role');
    this.agentId = localStorage.getItem('AgentId');
    if (this.role === 'PC Site Admin') {
      this.SiteAdminLogin = true;
      this.ResolutionLogin = true;
    } else if (this.role === 'PC Resolution Manager' ){
      this.ResolutionManagerLogin = true;
      this.ResolutionLogin = true;
      this.HomePage = false;
      this.isVendorLogged();
    }
    this.isNavigate = localStorage.getItem('isNavigate');
    if (this.isNavigate === 'true') {
      if (this.role === 'PC PAR Admin' && this.router.navigate(['/par/dashboard/Dashboard'])) {
        this.PARAdminPARClicked();
        localStorage.setItem('isNavigate', 'false');
      } else if (this.role === 'PC Client' && this.router.navigate(['/agentsearchlist'])) {
        this.ClientAgentClicked();
        localStorage.setItem('isNavigate', 'false');
      } else if (this.role === 'PC PAR Vendor Relations') {
        this.qacRole = true;
        this.ResolutionLogin = true;
        localStorage.setItem('isNavigate', 'false');
      } else if (this.role === 'PC Site Admin') {
        this.PARAdminPARClicked();
        this.SiteAdminLogin = true;
        localStorage.setItem('isNavigate', 'false');
      }
      else {
        this.showToggle = false;
        this.homeBtnDisable = true;
        localStorage.setItem('isNavigate', 'false');
      }
      this.showHide = false;
      this.userName = localStorage.getItem('username');
      // to get the previous searched name from local storage when page got refresh
      this.headerValidationmsg = "Please enter alphanumeric characters only!!";
      this.SearchTermservice.searchdDash.subscribe(res => {
        this.searchBar = res;
      });
    }
    else if (this.role === 'PC PAR Admin' && localStorage.getItem("parClicked") === 'true') {
      this.PARAdminPARClicked();
    } else if (this.role === 'PC Client' && localStorage.getItem("agentClicked") === 'true') {
      this.ClientAgentClicked();
    }
    else if (this.role === 'PC Client' && localStorage.getItem("parClicked") === 'true') {
      this.showToggle = true;
      this.parIsSelected = true;
      this.parclicked = this.parIsSelected;
      localStorage.setItem("parClicked", this.parclicked);
      this.agentIsSelected = false;
      this.agentclicked = this.agentIsSelected;
      this.globalSearch = false;
      this.homeBtnDisable = false;
    }
    else if (this.role === 'PC PAR Admin' && localStorage.getItem("agentClicked") === 'true') {
      this.showToggle = true;
      this.parIsSelected = false;
      this.agentIsSelected = true;
      this.agentclicked = this.agentIsSelected;
      localStorage.setItem("agentClicked", this.agentclicked);
      this.homeBtnDisable = true;
    }
    else if (this.role === 'PC PAR Vendor Relations') {
      this.qacRole = true;
      this.ResolutionLogin = true;
    }
    else if (this.role === 'PC Site Admin' && localStorage.getItem("parClicked") === 'true') {
      this.PARAdminPARClicked();
      this.SiteAdminLogin = true;
      localStorage.setItem('isNavigate', 'false');
    } else if (this.role === 'PC Site Admin' && localStorage.getItem("agentClicked") === 'true') {
      this.ClientAgentClicked();
      this.SiteAdminLogin = true;
      localStorage.setItem('isNavigate', 'false');
    }
    else {
      this.showToggle = false;
      this.homeBtnDisable = true;
      this.headerValidationmsg = "Please enter alphanumeric characters only!!";
      this.SearchTermservice.searchdDash.subscribe(res => {
        this.searchBar = res;
      });
    }
  });
  }


  navigateToSearchlist() {
    if (this.router.url === '/agentsearchlist') {
      this.SearchTermservice.searchdDash.next(this.searchBar);
      this.searchBar = '';
    } else {
      this.router.navigate(['/agentsearchlist']);
      this.searchBar = '';
    }
  }

  navigateToHome() {
    // var role = localStorage.getItem('Role');
    localStorage.setItem("searchterm", '');
    if (this.role === 'PC Client' && this.agentIsSelected) {
      this.router.navigate(['/agentsearchlist']);
    } else if (this.role === 'PC Client' && this.parIsSelected) {
      this.router.navigate(['/par/dashboard/Dashboard']);
    } else if (this.role === 'PC PAR Admin' && this.parIsSelected) {
      this.router.navigate(['/par/dashboard/Dashboard']);
    } else if (this.role === 'PC PAR Admin' && this.agentIsSelected) {
      this.router.navigate(['/maindashboard']);
    } else if (this.role === 'PC PAR Vendor Relations') {
      this.router.navigate(['/maindashboard']);
    } else if (this.role === 'PC Site Admin' && this.parIsSelected) {
      this.router.navigate(['/par/dashboard/Dashboard']);
    } else if (this.role === 'PC Site Admin' && this.agentIsSelected) {
      this.router.navigate(['/maindashboard']);
    } 
  }

  parIsClicked() {
    this.router.navigate(['/par/dashboard/Dashboard']);
    this.globalSearch = false;
    this.parIsSelected = true;
    this.agentIsSelected = false;
    this.homeBtnDisable = false;
    this.parclicked = this.parIsSelected.toString();
    localStorage.setItem("parClicked", this.parclicked);
    localStorage.setItem("agentClicked", "false");
  }

  agentIsClicked() {
    this.globalSearch = true;
    this.homeBtnDisable = true;
    // var role = localStorage.getItem('Role');
    if (this.role === 'PC PAR Admin') {
      this.router.navigate(['/maindashboard']);
    } else if (this.role === 'PC Client') {
      this.router.navigate(['/agentsearchlist']);
    } else if (this.role === 'PC Site Admin') {
      this.router.navigate(['/maindashboard']);
    }
    this.parIsSelected = false;
    this.agentIsSelected = true;
    this.agentclicked = this.agentIsSelected.toString();
    localStorage.setItem("agentClicked", this.agentclicked);
    localStorage.setItem("parClicked", "false");
  }

  onKeydown(event) {
    if (this.enterDisable) {
      this.navigateToSearchlist();
    } else {
      this.iserror2 = true;
      this.msg = "Please enter atleast 3 characters!";
    }
  }

  onKeypress(event) {
    let regex = new RegExp("^[a-zA-Z0-9_ ]");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      this.iserror = false
      return false;
    } else {
      this.iserror = true;
      return true;
    }
  }

  searchChange(searchData) {
    localStorage.setItem("searchterm", searchData);
    if (this.searchBar.length > 2) {
      this.enterDisable = true;
      this.searchIcon = true;
    } else {
      this.searchIcon = false;
      this.enterDisable = false;
    }
  }

  dashboard() {
    this.router.navigate(['/maindashboard']);
    localStorage.removeItem('searchterm');
    this.searchBar = null;
  }

  logout() {
    this.oktaAuth.logout(`${window.location.origin}/logout`).then(() => {  
      localStorage.clear();
    })
    .catch((error)=>{
      console.log('OKTA sign out Error', error);
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ContactUsDialogComponent, {
      disableClose: true,
      width: '650px',
      height: '450px',
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  PARAdminPARClicked() {
    this.showToggle = true;
    this.parIsSelected = true;
    this.parclicked = this.parIsSelected;
    localStorage.setItem("parClicked", this.parclicked);
    this.agentIsSelected = false;
    this.agentclicked = this.agentIsSelected;
    localStorage.setItem("agentClicked", this.agentclicked);
    this.globalSearch = false;
    this.homeBtnDisable = false;
  }
  ClientAgentClicked() {
    console.log('inside agent clicked')
    this.showToggle = true;
    this.parIsSelected = false;
    this.agentIsSelected = true;
    this.agentclicked = this.agentIsSelected;
    localStorage.setItem("agentClicked", this.agentclicked);
    this.homeBtnDisable = true;
  }
  RoleManager() {
    this.homeBtnDisable = false;
    this.globalSearch = false;
    this.parManagerRole = true;
  }

  isVendorLogged() {
    this.showToggle = false;
    this.SiteAdminLogin = false;
    this.globalSearch = false;
  }

  manageUsers() {
    this.router.navigate(['manageusers']);
  }

  manageComplaints() {
    this.router.navigate(['par/managecomplaints']);
  }

  regionStateMap() {
    this.router.navigate(['par/regionstatemapping']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts